import { useCallback, useEffect, useState } from 'react';
/**
 * watches a value, and if it doesn't change back to false after a delay, the hook will return true.
 * As soon as the value changes back to false, the hook will return false.
 * @param value
 * @param delay
 */
export function useInteractionDelay(value: boolean, delay = 300) {
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState<number | undefined>(undefined);

  const clearTimer = useCallback(() => {
    if (timer) {
      clearTimeout(timer);
      setTimer(undefined);
    }
  }, [timer]);

  useEffect(() => {
    if (value) {
      clearTimer();
      setTimer(
        setTimeout(() => {
          setLoading(true);
        }, delay) as unknown as number,
      );
    } else {
      clearTimer();
      setLoading(false);
    }
    return clearTimer;
  }, [value, delay]);

  return loading;
}
